import * as yup from 'yup';

import { TrlFormattedMessagePlain } from '»utils/i18n';

export const recoverModalValidation = () =>
  yup.object().shape({
    user: yup
      .string()
      .required(TrlFormattedMessagePlain({ id: 'TRLT_UI-REQUIRED_FIELD' })),
  });
